import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import usePreventTouchMove from 'SRC/common/hooks/usePreventTouchMove';
import styles from './styles.scss';

type Fn = () => void;
interface BaseProps {
  title?: React.ReactNode;
  subTitle: React.ReactNode;
  okBtnText: string;
  className?: string;
  okCallback?: Fn;
  cancelCallback?: Fn;
  renderButton?: () => any;
  domWrap: HTMLDivElement;
  onClose?: Fn;
  hideCloseIcon?: boolean;
}

const AlertBox: React.FC<BaseProps> = (props) => {
  const {
    title,
    subTitle,
    domWrap,
    okBtnText,
    okCallback,
    renderButton,
    className,
    onClose,
    hideCloseIcon,
  } = props;
  const maskDomRef = useRef<HTMLDivElement>();
  const [forceReRender, setForceReRender] = useState(false);
  // 禁止mask滑动
  usePreventTouchMove(maskDomRef.current as HTMLDivElement);
  function canfirmFn() {
    if (domWrap) {
      ReactDOM.unmountComponentAtNode(domWrap);
      document.body.removeChild(domWrap);
    }
    onClose && onClose();
    okCallback && okCallback();
  }

  function closeFn() {
    if (domWrap) {
      ReactDOM.unmountComponentAtNode(domWrap);
      document.body.removeChild(domWrap);
    }
    onClose && onClose();
  }
  return (
    <div
      className={styles['mask-wrap']}
      ref={(ele) => {
        if (ele) {
          maskDomRef.current = ele;
          setForceReRender(!!ele);
        }
      }}
    >
      <div className={styles['confirm-content-wrapper']}>
        <div className={`${styles['confirm-content']} ${className}`}>
          <h3 className={styles['title']}>{title}</h3>
          <div className={`${styles['sub-title']} confirm-content-subtitle`}>
            {subTitle}
          </div>
          <div className={styles['btn-group']}>
            <div
              className={`${styles['confirm-btn']} alert-modal-comfirm-button`}
              onClick={canfirmFn}
            >
              {okBtnText}
              {renderButton && renderButton()}
            </div>
          </div>
          {!hideCloseIcon && (
            <div className={styles['close-icon']} onClick={closeFn} />
          )}
        </div>
      </div>
    </div>
  );
};

AlertBox.defaultProps = {
  title: '温馨提示',
  okBtnText: '确定',
};
export default AlertBox;
